import { makeStyles } from '@material-ui/core/styles';

export default function css() {

    return makeStyles(theme => ({
        root: {
            flexGrow: 1,
            padding: 20
        },
        paper: {
            color: theme.palette.text.secondary,
        },
        textField: {
            width: '100%'
        },
        mobile: {
            height: 300,
            overflowY: 'auto'
        },
        label: {
            color: "rgb(118, 118, 118)",
        }
    }));

}